import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '20px',
  },
  title: {
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '42px',
    color: '#1040C6',
    marginBottom: '15px'
  },
  subtitle: {
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '24px',
    color: '#454545',
    marginBottom: '15px'
  },
  link: {
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    textDecoration: 'underline',
    color: '#00BDFF',
  }
})

function Error(props) {
  const styles = useStyles()

  const onClick = () => {
    if (props.onTryAgain) {
      props.onTryAgain()
    }
  }

  if (props.statusCode === 404) {
    return (
      <div className={styles.root}>
        <div className={styles.content}>
          <span className={styles.title}>Convite Indisponível =(</span>
          <span className={styles.subtitle}>O convite que você tentou acessar expirou ou não existe mais.</span>
        </div>
      </div>
    )
  } else {
    return (
      <div className={styles.root}>
        <div className={styles.content}>
          <span className={styles.title}>Ocorreu algo inesperado! =(</span>
          <span className={styles.subtitle}>Entre em contato com o administrador do sistema ou tente novamente.</span>
          <span onClick={onClick} className={styles.link}>Clique aqui para tentar novamente</span>
        </div>
      </div>
    )
  }
}

export default Error
